import { SCHEDULE_TEMPLATES_PART01 } from './templates/scheduleTemplates.part01.js'
import { SCHEDULE_TEMPLATES_PART02 } from './templates/scheduleTemplates.part02.js'
import { SCHEDULE_TEMPLATES_PART03 } from './templates/scheduleTemplates.part03.js'
import { SKILL_TEMPLATES_PART01 } from './templates/skillTemplates.part01.js'
import { SKILL_TEMPLATES_PART02 } from './templates/skillTemplates.part02.js'
import { SKILL_TEMPLATES_PART03 } from './templates/skillTemplates.part03.js'
import { SKILL_TEMPLATES_PART04 } from './templates/skillTemplates.part04.js'
import { TRIGGER_TEMPLATES_PART01 } from './templates/triggerTemplates.part01.js'
import { TRIGGER_TEMPLATES_PART02 } from './templates/triggerTemplates.part02.js'
import { TRIGGER_TEMPLATES_PART03 } from './templates/triggerTemplates.part03.js'

/**
 * The Discover catalogue for every Pulse page. Schedule and trigger templates
 * carry the prompt the ask bar is filled with; skill templates carry the
 * instructions saved by "Add to my skills".
 */
export const DEMO_TEMPLATES = [
  ...SCHEDULE_TEMPLATES_PART01,
  ...SCHEDULE_TEMPLATES_PART02,
  ...SCHEDULE_TEMPLATES_PART03,
  ...TRIGGER_TEMPLATES_PART01,
  ...TRIGGER_TEMPLATES_PART02,
  ...TRIGGER_TEMPLATES_PART03,
  ...SKILL_TEMPLATES_PART01,
  ...SKILL_TEMPLATES_PART02,
  ...SKILL_TEMPLATES_PART03,
  ...SKILL_TEMPLATES_PART04,
]
